export enum ShiftStatus {
  TO_VERIFIED = 1,
  DENY = 2,
  ACCEPTED = 3,
  WAITING_FOR_EXPLANATION = 4
}
